import { createAction } from '@reduxjs/toolkit';
import { LifenError } from './error.type';

export const setError = createAction<LifenError>('SET_ERROR');
